import React from 'react';
import { resolveMainPhoto } from '../utils/profileMedia';

/**
 * Unified ProfileAvatar Component
 * 
 * Displays user/profile avatar with consistent fallback behavior.
 * Uses the unified resolver to handle all photo field variants.
 * 
 * Used across: Discover, Matches, Likes, Lounge, etc.
 */
export default function ProfileAvatar({ 
  profile, 
  size = 40,
  className = '',
  alt = 'Profile avatar'
}) {
  // Use unified resolver for all photo field variants
  const avatarUrl = resolveMainPhoto(profile);

  if (!avatarUrl) {
    return (
      <div
        style={{ width: size, height: size }}
        className={`rounded-full bg-slate-700 flex items-center justify-center text-slate-300 ${className}`}
      >
        <span style={{ fontSize: size * 0.5 }}>👤</span>
      </div>
    );
  }

  return (
    <img
      src={avatarUrl}
      alt={alt || profile?.display_name || 'Profile avatar'}
      style={{ width: size, height: size }}
      className={`rounded-full object-cover bg-slate-800 ${className}`}
      onError={(e) => {
        // If image fails to load, replace with fallback
        e.target.style.display = 'none';
        const fallback = document.createElement('div');
        fallback.style.width = `${size}px`;
        fallback.style.height = `${size}px`;
        fallback.className = `rounded-full bg-slate-700 flex items-center justify-center text-slate-300 ${className}`;
        fallback.innerHTML = `<span style="font-size: ${size * 0.5}px">👤</span>`;
        e.target.parentNode.replaceChild(fallback, e.target);
      }}
    />
  );
}
